import React from "react";
import Hero from "../components/Hero";
import ClientsSection from "../components/ClientsSection";
import HowItWorks from "../components/HowItWorks";
import Fleet from "../components/Fleet";
import TrustedAndLoved from "../components/TrustedAndLoved";
import WhyChooseUs from "../components/WhyChooseUs";
import WhyGoElectric from "../components/WhyGoElectric";
import RideSmartBanner from "../components/RideSmartBanner";
import EvLeasingSection from "../components/EvLeasingSection";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";

export default function HomePage() {
  return (
    <>
      <Hero />
      <ClientsSection />
      <Fleet />
      <HowItWorks />
      <TrustedAndLoved />
      <WhyChooseUs />
      <WhyGoElectric />
      {/* <RideSmartBanner /> */}
      <EvLeasingSection />
      <FAQSection />
      <CTASection />
    </>
  );
}
